import {UNIT_STATUS_OPTIONS} from "./UnitStatus";

const MAC_REGEX = /^([0-9A-Fa-f]{2}:){5}[0-9A-Fa-f]{2}$/;
const CORRECT_FILE_NAME_REGEX = /^(?!.*[%\/&?!*’();:@#\[\]]).*$/;

export const validateUnit = (name, status, technicalData, documents) => {
  const errors = [];
    if (!name?.length) {
      errors.push({
        field: "name",
        defaultMessage: "Muss einen Wert enthalten",
      });
    }
    if (!status) {
      errors.push({
        field: "status",
        defaultMessage: "Muss einen Wert enthalten",
      });
    }
    if (!!technicalData?.ont?.mac_address && !MAC_REGEX.test(technicalData.ont.mac_address)) {
      errors.push({
        field: "technicalData.ont.mac_address",
        defaultMessage: "Ungültiges MAC-Adressformat. Erwartetes Format: XX:XX:XX:XX:XX:XX.",
      });
    }
    if (!!technicalData?.cpe?.mac_address && !MAC_REGEX.test(technicalData.cpe.mac_address)) {
      errors.push({
        field: "technicalData.cpe.mac_address",
        defaultMessage: "Ungültiges MAC-Adressformat. Erwartetes Format: XX:XX:XX:XX:XX:XX.",
      });
    }
    if (technicalData?.port_gf_gv?.length > 6) {
      errors.push({
        field: "technicalData.port_gf_gv",
        defaultMessage: "Port GF-GV darf maximal 6 alphanumerische Zeichen haben",
      });
    }
    if (technicalData?.port_gf_ap?.length > 20) {
      errors.push({
        field: "technicalData.port_gf_ap",
        defaultMessage: "Port GF-AP darf maximal 20 alphanumerische Zeichen haben",
      });
    }
    if (documents?.length) {
      documents.forEach((doc) => {
        if (!CORRECT_FILE_NAME_REGEX.test(doc.displayName)) {
          errors.push({
            field: "unitDocuments",
            defaultMessage: "Im Dateinamen sind nur Buchstaben, Zahlen und - _ . ~ erlaubt",
          });
        }
      });
    }

  return errors;
}